import {
  RazorImageFallback,
  RazorRadioCheck,
  RazorTextTrim,
} from "../../../../../components/razor-reuse";
import { useState } from "react";
import { useSelector } from "react-redux";
import { ALL_ICONS } from "../../../../../assets/icons/AllIcons";
import CurrencyText from "../../../../../components/fragment/cur-text/CurrencyText";
import StatusFragment from "../../../../../components/fragment/status/StatusFragment";
import RootState from "../../../../../redux/type";
import { formatTime } from "../../../../../utils/Helper";
import CollapseFragment from "../../../../../components/fragment/collapse/CollapseFragment";
import AccordionBox from "../../../../../components/AccordionBox";
import { useOverviewContext } from "../../CustomerSingle";
import { systemRoles } from "../../../../../utils/roles";
import KycAccordOne from "./component/KycAccordionOne";
import KycAccordTwo from "./component/KycAccordionTwo";
import ResubmissionAccord from "./component/ResubmissionAccordion";

export const valueClass =
  "text-[#596080] font-medium text-[14px] flex items-center [&_svg]:size-[12px] [&_svg]:mr-[4px]";
export const labelClass = "text-[12px] text-[#758089]";

const OverviewComponent = () => {
  const context = useOverviewContext();

  const { customer } = useSelector((state: RootState) => state.customer); // Customer data
  const { user } = useSelector((state: RootState) => state.auth);

  const filteredId: any[] = customer?.documents?.filter(
    (vals: any) =>
      vals?.document_type === "PASSPORT" ||
      vals?.document_type === "ID_CARD" ||
      vals?.document_type === "DRIVERS_LICENCE" ||
      vals?.document_type === "RESIDENCE_PERMIT" ||
      vals?.document_type === "DRIVERS",
  );

  const filteredSelfie: any[] = customer?.documents?.filter(
    (vals: any) => vals?.document_type === "SELFIE",
  );

  const filteredPOA: any[] = customer?.documents?.filter(
    (vals: any) =>
      vals?.document_type === "UTILITY_BILL" || vals?.document_type === "POA",
  );

  const filteredSOF: any[] = customer?.documents?.filter(
    (vals: any) =>
      vals?.document_type === "BANK_STATEMENT" ||
      vals?.document_type === "PAY_SLIP" ||
      vals?.document_type === "TAX_RETURN" ||
      vals?.document_type === "INVESTMENT_CERTIFICATES" ||
      vals?.document_type === "CONTRACT_NOTES" ||
      vals?.document_type === "SIGNED_WILL" ||
      vals?.document_type === "GIFT_DECLARATION" ||
      vals?.document_type === "LOAN_AGREEMENT" ||
      vals?.document_type === "SIGNED_SALES_CONTRACT" ||
      vals?.document_type === "PROPERTY_OWNERSHIP_DOCUMENTS" ||
      vals?.document_type === "FILE_ATTACHMENT" ||
      vals?.document_type === "OTHERS" ||
      vals?.document_type === "SOF",
  );

  const levelOne = [
    // { name: "Profile Info", active: customer?.kyc?.user_id ? true : false },
    { name: "ID Verification", active: filteredId?.length > 0 ? true : false },
    {
      name: "Liveliness Check",
      active: filteredSelfie?.length > 0 ? true : false,
    },
    {
      name: "Proof of Address",
      active: customer?.kyc?.address_verified,
    },
  ];

  const levelTwo = [
    {
      name: "Source of Funds",
      active: filteredSOF?.length > 0 ? true : false,
    },
  ];

  const [bvnOpen, setbvnOpen] = useState(false);
  const [otherOpen, setotherOpen] = useState(false);

  return (
    <div className="pb-[30px]">
      <div
        // onClick={() => {
        //   console.log(customer);
        // }}
        className="four-card-grid-box"
      >
        {/* grid box start */}

        <AccordionBox title="Customer Details">
          <div className="lg:flex max-md:space-y-[20px] gap-[10px] bg-white px-4 py-[30px]">
            <div className="grid-box  border border-[#e6e6e6] rounded-lg !max-md:w-full lg:w-[45%]">
              {/* title icon end */}
              <div className="flex justify-between items-center">
                {/* profile img start */}
                <div className="profile-img-box">
                  <RazorImageFallback
                    loadSize={45}
                    url={customer?.profile_picture}
                  >
                    <figure className="img-box">
                      {ALL_ICONS?.profile_img}
                    </figure>
                  </RazorImageFallback>
                </div>
                {customer?.account_status && (
                  <>
                    {customer?.account_status === "active" &&
                    user?.permissions?.includes(systemRoles[8]) ? (
                      <button
                        onClick={() => {
                          context?.setStatusModal({
                            visible: true,
                            status: "suspend",
                            reason: "",
                          });
                        }}
                        className="text-[14px] text-primary border border-primary py-[6px] px-[10px] rounded-[8px]"
                      >
                        Suspend User
                      </button>
                    ) : customer?.account_status === "suspended" &&
                      user?.permissions?.includes(systemRoles[9]) ? (
                      <button
                        onClick={() => {
                          context?.setStatusModal({
                            visible: true,
                            status: "unsuspend",
                            reason: "",
                          });
                        }}
                        className="text-[14px] text-primary border border-primary py-[6px] px-[10px] rounded-[8px]"
                      >
                        Unsuspend User
                      </button>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {/* profile img end */}
              </div>
              {/* label value wrapper box start */}
              <div className="label-value-wrapper-box">
                {/* label value box start */}
                <div className="label-value-box">
                  <p className="label">First Name:</p>
                  <p className="value">{customer?.first_name || "---"}</p>
                </div>
                {/* label value box end */}
                {/* label value box start */}
                <div className="label-value-box">
                  <p className="label">Middle Name:</p>
                  <p className="value">{customer?.kyc?.middle_name || "---"}</p>
                </div>
                {/* label value box end */}
                {/* label value box start */}
                <div className="label-value-box">
                  <p className="label">Last Name:</p>
                  <p className="value">{customer?.last_name || "---"}</p>
                </div>
                {/* label value box end */}

                {/* label value box start */}
                <div className="label-value-box">
                  <p className="label">Email:</p>
                  <p className="value flex items-center [&_svg]:ml-[2px]">
                    {RazorTextTrim(customer?.email, 22) || "---"}
                    {/* {verifiedSvg} */}
                  </p>
                </div>
                {/* label value box end */}
                {/* label value box start */}
                <div className="label-value-box">
                  <p className="label">Country:</p>
                  <div className="value">
                    {customer?.resident_country ? (
                      <CurrencyText
                        currency={customer?.resident_country?.iso_code}
                        url={customer?.resident_country?.flag_url}
                        text={customer?.resident_country?.name}
                      />
                    ) : (
                      "---"
                    )}
                  </div>
                </div>
                {/* label value box end */}
                {/* label value box start */}
                {/* <div className="label-value-box">
                  <p className="label">Nationality:</p>
                  <div className="value">
                    <CurrencyText
                      currency={`ngn`}
                      url={
                        customer?.kyc?.nationality_country_id?.flag_url || ""
                      }
                      text={customer?.kyc?.nationality_country_id?.name}
                    />
                  </div>
                </div> */}

                <div className="label-value-box">
                  <p className="label">Sign Up:</p>
                  <p className="value">{formatTime(customer?.signed_up)}</p>
                </div>
                {/* label value box end */}
                {/* label value box start */}
                <div className="label-value-box">
                  <p className="label">Account Status:</p>
                  <p className="value">
                    <StatusFragment
                      text={customer?.account_status || "---"}
                      className={
                        customer?.account_status === "active"
                          ? "success"
                          : customer?.account_status === "inactive"
                            ? "pending"
                            : customer?.account_status === "suspended"
                              ? "failed"
                              : ""
                      }
                    />
                    {/* {customer?.account_status || "---"} */}
                  </p>
                </div>
                {/* label value box end */}
                {/* label value box start */}
                <div className="label-value-box">
                  <p className="label">Verification Status:</p>
                  <p className="value">
                    {customer?.verification_status || "---"}
                  </p>
                </div>
                <div className="label-value-box">
                  <p className="label">Bridge Status:</p>
                  <p className="value">
                    {customer?.bridge_customer_status || "---"}
                  </p>
                </div>
                {/* label value box end */}
              </div>
              {/* label value wrapper box end */}
            </div>
            <div className="flex-1 p-[1.75rem] border border-[#e6e6e6] rounded-lg">
              <h4 className="font-medium text-[14px] text-[#596080]">
                EDD Questionnaire Responses
              </h4>
              <div className="grid gap-y-[20px] gap-x-[12px] grid-cols-2 w-full mt-5">
                <div className="space-y-2">
                  <h5 className={labelClass}>Purpose of Account:</h5>
                  {customer?.questionaire?.purpose?.map((item: string) => (
                    <p key={item} className={valueClass}>
                      {checkSvg}
                      {item}
                    </p>
                  ))}
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Expected Currencies:</h5>
                  {customer?.questionaire?.currencies?.map((item: any) => (
                    <p key={item} className={valueClass}>
                      {checkSvg}

                      {item?.code}
                    </p>
                  ))}
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Monthly Turnover:</h5>
                  <p className={valueClass}>
                    {customer?.questionaire?.monthly_turnover || "---"}
                  </p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Yearly Turnover:</h5>
                  <p className={valueClass}>
                    {customer?.questionaire?.yearly_turnover || "---"}
                  </p>
                </div>
                <div className="space-y-2 col-span-2">
                  <h5 className={labelClass}>Transaction Sources:</h5>
                  {customer?.questionaire?.countries?.map((item: any) => (
                    <p key={item} className={valueClass}>
                      {checkSvg}
                      <CurrencyText
                        currency={item?.to?.iso_code}
                        url={item?.to?.flag_url}
                        text={item?.to?.name}
                      />
                      <span className="block rounded-full w-[8px] h-[2px] bg-black mx-[8px]" />
                      <CurrencyText
                        currency={item?.from?.iso_code}
                        url={item?.from?.flag_url}
                        text={item?.from?.name}
                      />
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </AccordionBox>
        {/* grid box end */}
        {/* right wrap start */}
        <div className="right-wrap-box">
          <div className="kyc-wrapper-info-box">
            <p className="title">KYC Information</p>
            {/* bvn collapse one start */}
            <CollapseFragment
              title="Level 1"
              titleColor="rgba(115, 71, 146, 1)"
              iconColor="rgba(115, 71, 146, 1)"
              disableDefaultControl
              collapse={bvnOpen}
              onCollapse={() => {
                setbvnOpen(!bvnOpen);
              }}
            >
              <div className="name-toggle-check-box-wrapper">
                {levelOne?.map((chi, idx) => {
                  return (
                    <div key={idx} className="name-toggle-check-box">
                      <p className="name">{chi?.name}</p>
                      <RazorRadioCheck
                        color="white-light"
                        key={`${chi?.name}-${idx}-sks`}
                        checked={chi?.active}
                        id={`${chi?.name}-${idx}` as any}
                        className="radio"
                        name={`${chi?.name}-${idx}-sks`}
                      />
                    </div>
                  );
                })}
              </div>
            </CollapseFragment>
            {/* bvn collapse one end */}
            {/* kyc collapse one start */}
            <CollapseFragment
              title="Level 2"
              titleColor="rgba(115, 71, 146, 1)"
              iconColor="rgba(115, 71, 146, 1)"
              disableDefaultControl
              collapse={otherOpen}
              onCollapse={() => {
                setotherOpen(!otherOpen);
              }}
            >
              <div className="name-toggle-check-box-wrapper">
                {levelTwo?.map((chi, idx) => {
                  return (
                    <div key={idx} className="name-toggle-check-box">
                      <p className="name">{chi?.name}</p>
                      <RazorRadioCheck
                        color="white-light"
                        key={`${chi?.name}-${idx}-sks`}
                        checked={chi?.active}
                        id={`${chi?.name}-${idx}` as any}
                        className="radio"
                        name={`${chi?.name}-${idx}-sks`}
                      />
                    </div>
                  );
                })}
              </div>
            </CollapseFragment>
            {/* kyc collapse one end */}
          </div>
        </div>
      </div>
      <section className="space-y-[35px]">
        {/* KYC Levels */}

        {user?.permissions?.includes(systemRoles[4]) && (
          <>
            <KycAccordOne />
            <KycAccordTwo />
            {user?.permissions?.includes(systemRoles[38]) && (
              <ResubmissionAccord />
            )}
          </>
        )}
        {/* Risk Level */}
        <AccordionBox defaultState={false} svgIcon="caution" title="Risk Level">
          <section className="bg-white min-h-[340px] px-[35px] py-[40px] space-y-[20px]">
            <div className="space-y-[8px]">
              <h5 className="text-[14px] font-medium text-[#596080]">
                Device labels
              </h5>
              {customer?.risk_labels?.device?.length > 0
                ? customer?.risk_labels?.device?.map(
                    (item: string, idx: number) => (
                      <span
                        key={idx}
                        className="text-[12px] w-fit block text-[#A47008] bg-[#FFC0430D] rounded-[4px] px-[10px] py-[5px]"
                      >
                        {item}
                      </span>
                    ),
                  )
                : "---"}
            </div>
            <div className="space-y-[8px]">
              <h5 className="text-[14px] font-medium text-[#596080]">
                Cross Check labels
              </h5>
              {customer?.risk_labels?.crossCheck?.length > 0
                ? customer?.risk_labels?.crossCheck?.map(
                    (item: string, idx: number) => (
                      <p
                        key={idx}
                        className="text-[12px] w-fit text-[#A47008] bg-[#FFC0430D] rounded-[4px] px-[10px] py-[5px]"
                      >
                        {item}
                      </p>
                    ),
                  )
                : "---"}
            </div>
          </section>
        </AccordionBox>
      </section>
    </div>
  );
};

export default OverviewComponent;

const checkSvg = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // className="mr-[4px]"
  >
    <path
      d="M10 3L4.5 8.5L2 6"
      stroke="#596080"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
